export const SxOneTextField = {
    backgroundColor: "#fff",
    borderRadius: '5px',
    border: 'none',
    "& fieldset": { border: 'none' },
    margin: 0,
    height: '30px',
    width: '100%',
    padding: "1px"
}

export const SxOneInputProps = {
    height: '30px'
    // margin: "0 !important"
}
